export const rolesTypes = {
  ADD_PERMISSIONS: '[Roles] PERMISSIONS ADD',
  ADD_ROLES: '[Roles] ROLES ADD',
};
